// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"47d0334e","421":"8038e0d6","557":"ed17e235","787":"28cb0dcd","859":"02f299dd","952":"230737f1"}[chunkId] + ".chunk.js";
};